var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { mergeConfig } from './config';
import { canUseDOM } from 'exenv';
import { addUserKey, httpApiCall } from '../utils/misc';
import { authChannel } from '../utils/channels';
import { isExtendedSocial, SOCIAL, } from '../types';
import { createVerificationURL } from '../utils/verificationUrl';
import * as Sentry from '@sentry/browser';
// let oldUserData: any = null;
var STORAGE_TOKEN_NAME = 'auth_token';
var STORAGE_USER_INFO_NAME = 'user_info';
var STORAGE_LOGINTYPE_NAME = 'login_type';
// aggiungo le chiavi delle informazioni salvate su localstorage fra quelle che devono essere resettate in caso di
// cambio utente / logout
addUserKey([
    STORAGE_LOGINTYPE_NAME,
    STORAGE_USER_INFO_NAME,
    STORAGE_TOKEN_NAME,
]);
function loadUserDataFromLS() {
    if (!canUseDOM) {
        return {};
    }
    var userDataString = localStorage.getItem(STORAGE_USER_INFO_NAME);
    if (!userDataString) {
        return {};
    }
    return JSON.parse(userDataString);
}
function getUserData() {
    return loadUserDataFromLS();
}
function getValidToken() {
    if (!canUseDOM) {
        return null;
    }
    return localStorage.getItem(STORAGE_TOKEN_NAME);
}
var setAuthToken = function (token) {
    if (canUseDOM) {
        localStorage.setItem(STORAGE_TOKEN_NAME, token);
    }
};
function setUserData(data) {
    if (canUseDOM) {
        // oldUserData = data;
        localStorage.setItem(STORAGE_USER_INFO_NAME, JSON.stringify(data.user));
    }
}
function setLoginType(loginType) {
    if (canUseDOM) {
        localStorage.setItem(STORAGE_LOGINTYPE_NAME, loginType);
    }
}
var getLoginType = function () {
    if (canUseDOM) {
        var val_1 = localStorage.getItem(STORAGE_LOGINTYPE_NAME);
        if (!val_1) {
            return undefined;
        }
        else if (isExtendedSocial(val_1)) {
            return val_1;
        }
        else {
            console.error("Corrupted localStorage key " + STORAGE_LOGINTYPE_NAME + "=" + val_1);
            Sentry.withScope(function (scope) {
                scope.setExtra('Chiave di localStorage', STORAGE_LOGINTYPE_NAME);
                scope.setExtra('Valore di localStorage', val_1);
                Sentry.captureException(new Error('Corrupted localStorage key'));
            });
        }
    }
    return undefined;
};
function isLogged() {
    if (!canUseDOM) {
        return false;
    }
    var data = getUserData();
    var key = getValidToken();
    return Boolean(data && data.id && key);
}
function setAuth(serverAuth, loginType, isSwitch) {
    var oldUser = getUserData();
    setUserData(serverAuth.auth);
    setAuthToken(serverAuth.authorization);
    if (loginType) {
        setLoginType(loginType);
    }
    var newUser = getUserData();
    authChannel.postMessage({
        type: 'USER_CHANGED',
        args: { oldUser: oldUser, newUser: newUser, isSwitch: Boolean(isSwitch) },
    });
}
function logout() {
    var oldUser = getUserData();
    // azzero le chiavi localstorage legate all'utente
    var keysToInvalidate = JSON.parse(localStorage.getItem('@food/userKeys') || '[]');
    keysToInvalidate.forEach(function (key) { return localStorage.removeItem(key); });
    authChannel.postMessage({
        type: 'USER_CHANGED',
        args: { newUser: null, oldUser: oldUser },
    });
}
var auth = function (partialConfig) {
    var config = mergeConfig(partialConfig);
    var origin = canUseDOM ? window.location.origin : '';
    var redirectUrl = config.OAUTH_REDIRECT_URI;
    var SOCIAL_TYPES = {
        GOOGLE: {
            key: SOCIAL.GOOGLE,
            label: 'Sign in with Google',
            loginURL: function () {
                return config.GOOGLE_AUTH_URL + "&redirect_uri=" + redirectUrl + "&state=" + encodeURIComponent(JSON.stringify({ origin: origin }));
            },
        },
        FACEBOOK: {
            key: SOCIAL.FACEBOOK,
            label: 'Sign in with Facebook',
            loginURL: function () {
                return config.FACEBOOK_AUTH_URL + "&redirect_uri=" + redirectUrl + "&state=" + encodeURIComponent(JSON.stringify({ origin: origin }));
            },
        },
        LINKEDIN: {
            key: SOCIAL.LINKEDIN,
            label: 'Sign in with LinkedIn',
            loginURL: function () {
                return config.LINKEDIN_AUTH_URL + "&redirect_uri=" + redirectUrl + "&state=" + encodeURIComponent(JSON.stringify({ origin: origin }));
            },
        },
    };
    function authenticate(args, tokens, needsAuth, redirect) {
        var _a;
        if (tokens === void 0) { tokens = {}; }
        if (needsAuth === void 0) { needsAuth = false; }
        return __awaiter(this, void 0, void 0, function () {
            var privacyOptIns, callBody, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        privacyOptIns = [];
                        if (args.newsletterAccepted) {
                            privacyOptIns.push('TRANSFER');
                        }
                        callBody = {
                            sourceApp: args.sourceApp,
                            email: args.email,
                            password: args.password,
                            cryptoRenewToken: args.cryptoRenewToken,
                            socialType: args.socialType,
                            grantToken: args.grantToken,
                            options: __assign(__assign(__assign({ role: args.role, workEmail: args.workEmail, EmailDomain_id: args.EmailDomain_id, tosApproved: args.tosApproved, privacyOptIns: privacyOptIns, verificationUrl: createVerificationURL(config.VERIFICATION_URL, redirect) }, (needsAuth
                                ? {
                                    authToken: (_a = getValidToken()) === null || _a === void 0 ? void 0 : _a.replace('Bearer ', ''),
                                }
                                : {})), { redirectUri: config.OAUTH_REDIRECT_URI }), tokens),
                        };
                        return [4 /*yield*/, httpApiCall(callBody, config.AUTH_ENDPOINT, config.TARGET_SITE)];
                    case 1:
                        result = _b.sent();
                        return [2 /*return*/, {
                                success: result.success,
                                payload: result,
                            }];
                }
            });
        });
    }
    /*async function trySocialUpgrade(
        grantToken: string,
        socialType: SOCIAL,
        authToken: string,
    ): Promise<IWrappedResponse> {
        const origin = canUseDOM ? window.location.origin : '';

        const result = await httpApiCall(
            {
                sourceApp: config.TARGET_SITE,
                socialType,
                grantToken,
                options: {
                    authToken: authToken.replace('Bearer ', ''),
                    redirectUri: origin + config.OAUTH_REDIRECT_URI,
                },
            },
            config.AUTH_ENDPOINT,
            config.TARGET_SITE,
        );
        return { success: result.success === true, payload: result };
    }
    */
    return {
        SOCIAL_TYPES: SOCIAL_TYPES,
        authenticate: authenticate,
    };
};
export { auth, isLogged, getValidToken, getUserData, getLoginType, setAuth, setAuthToken, logout, };
//# sourceMappingURL=auth.js.map